import { useTranslation } from "react-i18next"
import { LIKERT_VARIANTS } from "../../questions/constants"
import { MultiAnswerChoices } from "./MultiAnswerSingle"
import type { IMultiAnswerProps } from "./types"

export function MultiAnswerLikert(props: IMultiAnswerProps) {
  const { t } = useTranslation()
  const variants = LIKERT_VARIANTS[props.question.meta?.category]!.slice().reverse()
  const choices = variants.map((variant) => ({ ...variant, label: t(variant.label) }))

  return <MultiAnswerChoices choices={choices} {...props} />
}
